const getTemplateBody = (
  header: string,
  body: string,
  footer: string
): string => {
  return `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html data-editor-version="2" class="sg-campaigns" xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1" />
        <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700%26display=swap" rel="stylesheet" />
        <style type="text/css">
            * {
                box-sizing: border-box;
            }
            body {
                background: #f5f5f5;
                font-family: Poppins, Helvetica;
                font-size: 16px;
            }
            body,
            p,
            div {
                font-family: Poppins, Helvetica;
            }
            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                font-family: Poppins, Helvetica;
                margin-bottom: 20px;
                font-weight: 600;
                color: #000;
            }

            body a {
                text-decoration: none;
            }

            p {
                font-size: 15px;
                line-height: 22px;
                margin: 0;
                padding: 0;
                color: #000;
            }

            h1 {
                font-size: 22px;
                line-height: 33px;
            }

            a {
                text-decoration: none;
            }

            .logo {
                width: 120px;
                height: 32px;
            }

            .logo-footer {
                margin-top: 5px;
                margin-left: 25px;
                margin-bottom: 5px;
                max-width: 60px;
            }

            .wrapper {
                background: #f9fafe;
            }

            .footer-row {
                display: flex;
                flex-direction: row;
                padding-top: 20px;
                padding-left: 20px;
            }

            .footer-row > div {
                width: 100%;
            }

            .footer-row-1 {
                margin-left: 50px;
                display: flex;
                flex-direction: row;
                padding-right: 20px;
            }

            .footer-header {
                font-size: 16px;
                color: #1c0066;
                font-weight: 700;
                line-height: 22px;
                margin-bottom: 17px;
            }

            .footer-header span {
                color: #1de589;
            }

            .social-links {
                display: flex;
                flex-direction: row;
                margin-left: auto;
            }

            .social-links-logo {
                width: 22px;
                height: 22px;
            }

            .applinks {
                display: flex;
                flex-direction: row;
                background: #1de589;
                padding: 10px 20px 5px 20px;
                margin-left: 50px;
                border-radius: 12px 0 12px 0;
            }

            .applinks img {
                width: 74px;
                height: 22px;
            }

            .applinks a {
                font-size: 13px;
                color: #1c0066;
            }

            .footnote td {
                padding: 20px 0;
            }

            .footnote p {
                text-align: center;
                font-size: 10px;
                line-height: 18px;
                margin: 0;
            }

            .footnote-link {
                color: #035dce;
            }

            .hairline {
                border: 0;
                height: 0.5px;
                background: #acb1c4;
                margin-bottom: 25px;
                margin-top: 25px;
            }

            .hairline-2 {
                display: flex;
                flex-direction: row;
            }

            .hairline-2a {
                height: 1px;
                background: #1c0066;
                width: 75%;
            }

            .hairline-2b {
                height: 1px;
                background: #1de589;
                width: 25%;
            }

            .content-table .header {
                height: 60px;
                background: transparent linear-gradient(0deg, #e7ecfc 0%, #ffffff 100%) 0% 0% no-repeat padding-box;
            }

            .content-table tr.header > td {
                padding: 0 20px;
            }

            .content-table tr.header > td td {
                padding-top: 5px;
                vertical-align: middle;
            }

            .content-table .content td {
                padding: 30px 30px 0px;
                background: #fff;
            }

            .content-table tr.footer {
                background: #fff;
            }

            .content-table .footer td {
                border-radius: 0 0 12px 12px;
            }

            .content-table .content-link a {
                font-size: 15px;
                font-family: Helvetica;
                font-weight: bold;
                color: white;
                padding: 14px 30px;
                background: #1c0066 0% 0% no-repeat padding-box;
                box-shadow: 0px 4px 6px #3535486a;
                border-radius: 6px;
                margin: 16px 0;
                display: inline-block;
            }

            .custom-content {
                margin-bottom: 25px;
            }

            @media screen and (max-width: 480px) {
                .logo-footer {
                    display: none;
                }

                .footer-row-1 {
                    margin-left: 0;
                }
                
                .footer-header br {
                    display: none;
                }
                
                .social-links {
                    margin-left: 5px;
                }

                .applinks {
                    margin-left: -20px;
                }

                .content-table .content > td {
                    padding: 30px 10px 30px;
                    background: #fff;
                }

                .content-table .content-link a {
                    text-align: center;
                    padding: 19px 19px;
                }
            }
        </style>
    </head>

    <body>
        <table class="wrapper" cellpadding="0" cellspacing="0" width="100%">
            <tr>
                <td class="wrapper-left"></td>
                <td class="wrapper-center" width="778px">
                    <table class="content-table" cellpadding="0" cellspacing="0" width="100%">
                        <tr class="content">
                            <td>
                                <a href="https://yelsa.co.nz">
                                    <img src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/baa7f5c1-8b94-49bf-953e-82d72a91fee0/240x65.png" alt="Yelsa" class="logo" />
                                </a>
                                <hr class="hairline" />
                                <h1>${header}</h1>
                                <div class="custom-content">${body}</div>
                                <div class="custom-content">${footer}</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="hairline-2">
                                    <div class="hairline-2a"></div>
                                    <div class="hairline-2b"></div>
                                </div>
                            </td>
                        </tr>
                        <tr class="footer">
                            <td>
                                <div class="footer-row">
                                    <a href="https://yelsa.co.nz">
                                        <img src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/482e5037-de35-4dae-b7ae-17d9b68135db/120x135.png" alt="Yelsa" class="logo-footer" />
                                    </a>
                                    <div>
                                        <div class="footer-row-1">
                                            <span class="footer-header">
                                                Technology designed to <span>ease friction</span>
                                                <br />
                                                in real estate marketing and sales
                                            </span>

                                            <div class="social-links">
                                                <a href="https://www.facebook.com/YelsaTech">
                                                    <img class="social-links-logo" src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/5e2ba627-8727-400f-8fe3-c4740eceb4b8/44x44.png" alt="Facebook" />
                                                </a>
                                                <a href="https://instagram.com/yelsaconnect" style="margin-left: 5px; margin-right: 5px;">
                                                    <img class="social-links-logo" src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/8458145c-a455-4cb3-aa3c-06d3dbbc7c68/44x44.png" alt="Instagram" />
                                                </a>
                                                <a href="https://www.linkedin.com/company/yelsa-tech">
                                                    <img class="social-links-logo" src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/fbf63a90-6603-4f73-9117-a343fad1537d/44x44.png" alt="LinkedIn" />
                                                </a>
                                            </div>
                                        </div>

                                        <div class="applinks">
                                            <div>
                                                <a href="https://apps.apple.com/nz/app/yelsa/id1491482377">
                                                    <img src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/72ee6add-50f8-4286-b236-2be598f97a0c/220x67.png" alt="PlayStore" />
                                                </a>
                                                <a href="https://play.google.com/store/apps/details?id=com.yelsa">
                                                    <img src="http://cdn.mcauto-images-production.sendgrid.net/48cb123634ee3a6c/66d03954-0fa0-47c9-afd6-55bdfda13892/220x67.png" alt="AppStore" />
                                                </a>
                                            </div>
                                            <a href="https://www.yelsa.co.nz" style="margin-left: auto;">
                                                www.yelsa.co.nz
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr class="footnote">
                            <td>
                                <p>
                                    This message was sent to {{email}}. If you don’t want to receive these emails from Yelsa in the future, please
                                    <a class="footnote-link" href="<%asm_preferences_raw_url%>">unsubscribe</a>.
                                </p>
                                <p>
                                    © Yelsa Limited. All rights reserved.
                                </p>
                            </td>
                        </tr>
                    </table>
                </td>
                <td class="wrapper-right"></td>
            </tr>
        </table>
    </body>
</html>
`;
};

export default getTemplateBody;
